import { FC } from "react";
import { useTranslation } from "react-i18next";
import Modal from "Components/UI/Modal";
import Button from "Components/UI/Button";
import {
  IAlertMoveFilesData,
  getAlertMoveFilesTitle,
  getAlertMoveFilesDescriptionHeader,
  getAlertMoveFilesDescriptionFooter,
} from "../alertUtils";
import { AlertWrapper, Buttons } from "../styles";

interface IAlertMoveFiles {
  visible: boolean;
  items: IAlertMoveFilesData[];
  onChangeFileName?: (fileId: string, value: string) => void;
  onCancel: () => void;
  onAction: () => void;
}

const AlertMoveFiles: FC<IAlertMoveFiles> = ({
  visible,
  items,
  onChangeFileName,
  onCancel,
  onAction,
}) => {
  const { t } = useTranslation(['listagemArquivos', 'common']);
  const modalTitle = items.length === 1
    ? getAlertMoveFilesTitle(items[0].type)
    : t('listagemArquivos:moveFiles.conflictsDetected');

  const buttons = (
    <Buttons>
      <div />
      <div className="rightButtons">
        <Button
          type="text"
          className="buttonCancel"
          onClick={onCancel}
        >
          {t('common:cancel')}
        </Button>
        <Button
          type="primary"
          className="buttonConfirm"
          onClick={onAction}
        >
          {t('listagemArquivos:moveFiles.continue')}
        </Button>
      </div>
    </Buttons>
  );

  return (
    <Modal
      title={modalTitle}
      width={450}
      visible={visible}
      footerButtons={buttons}
      footerActive={false}
      customClassName
      newHeader
      onCancel={onCancel}
    >
      <AlertWrapper>
        {items.map(item => (
          <div key={item.type} className="content">
            {items.length > 1 && (
              <div className="sectionTitle">
                {getAlertMoveFilesTitle(item.type)}
              </div>
            )}
            {getAlertMoveFilesDescriptionHeader(
              item.type,
              item.filesData.Revision,
              item.checkData?.Revision,
            )}
            {getAlertMoveFilesDescriptionFooter(
              item.type,
              item.filesData.FileId,
              item.checkData?.fileNameNewRevision,
              item.checkData?.fileNameCopy,
              onChangeFileName,
            )}
          </div>
        ))}
      </AlertWrapper>
    </Modal>
  );
};

export default AlertMoveFiles;
